import Text from '../../SidePanel/RightPanel/PropertiesControllerText.jsx'
import Analyse from '../components/PropertiesControllerAnalyse.jsx'
import ButtonExportModel from '../components/PropertiesPaneButtonExportModel.jsx'
import ModulePropertiesPane from '../_MODULE/ModulePropertiesPane.jsx'
import Model from './ModelPm.mjs'

export default function PropertiesPanePm(props) {
    return (
        <ModulePropertiesPane
            //buttons={<ButtonExportModel type="bf" />}

            controllers={
                <>
                    <Text prop="pmNo" />
                    <Text prop="pmName" />
                </>
            }

            Model={Model}

            snSuffix={
                <Analyse
                    modes={[
                        'Reference',
                        'ReferenceCall',
                        'IsrfReference',
                    ]}
                />
            }

            versionLabel="知识地图版本号"
            {...props}
        />
    )
}
